import { Origins } from "models/ScopeThreeCategoryOne/ScopeThreeCategoryOne.model";
import { FieldValues, UseFormSetValue, UseFormTrigger, UseFormWatch } from "react-hook-form";

const resetFormValues = async (
    typeValue: string,
    index: number,
    origins: Origins[],
    setValue: UseFormSetValue<FieldValues>,
    trigger: UseFormTrigger<FieldValues>
) => {
    // Trigger validation for the main type
    await trigger(`${typeValue}`);

    // Reset primary fields
    const fieldsToReset = [
        "activityMappingRegionSpecId",
        "addressLabel",
        "address",
        "map",
    ];

    fieldsToReset.forEach((field) => {
        setValue(`${typeValue}.${index}.${field}`, null, { shouldValidate: true });
    });

    // Reset origins fields
    origins.forEach((_, originIndex) => {
        fieldsToReset.forEach((field) => {
            setValue(`${typeValue}.${index}.origins.${originIndex}.${field}`, null, { shouldValidate: true });
        });
    });
};

const addOriginHandler = (
    typeValue: string,
    index: number,
    watch: UseFormWatch<FieldValues>,
    setValue: UseFormSetValue<FieldValues>
) => {
    setValue(
        `${typeValue}.${index}.origins.0.addressLabel`,
        watch(`${typeValue}.${index}.addressLabel`)
    );
    setValue(
        `${typeValue}.${index}.origins.0.id`,
        watch(`${typeValue}.${index}.id`)
    );
    setValue?.(`${typeValue}.${index}.bestFitRegion`, undefined);
    setValue(`${typeValue}.${index}.multiOrigin`, true);
    setValue(
        `${typeValue}.${index}.origins.0.activityMappingRegionSpecId`,
        watch(`${typeValue}.${index}.activityMappingRegionSpecId`)
    );
    setValue?.(`${typeValue}.${index}.addressLabel`, null);
    setValue?.(`${typeValue}.${index}.activityMappingRegionSpecId`, null);
    setValue?.(`${typeValue}.${index}.bestFitRegion`, null);
    setValue(`${typeValue}.${index}.id`, undefined);
    setValue?.(`${typeValue}.${index}.address`, null);
};

const removeOriginHandler = (typeValue: string,
    index: number,
    watch: UseFormWatch<FieldValues>,
    setValue: UseFormSetValue<FieldValues>) => {
    setValue?.(`${typeValue}.${index}.origins.0.share`, null);
    setValue(`${typeValue}.${index}.multiOrigin`, false);
    setValue(
        `${typeValue}.${index}.addressLabel`,
        watch(`${typeValue}.${index}.origins.0.addressLabel`)
    );
    setValue?.(`${typeValue}.${index}.bestFitRegion`, undefined);
    setValue(
        `${typeValue}.${index}.address`,
        watch(`${typeValue}.${index}.origins.0.address`)
    );
    setValue(
        `${typeValue}.${index}.activityMappingRegionSpecId`,
        watch(`${typeValue}.${index}.origins.0.activityMappingRegionSpecId`)
    );
    setValue(`${typeValue}.${index}.origins`, []);
    setValue?.(`${typeValue}.${index}.bestFitRegion`, undefined);
}

export { resetFormValues, addOriginHandler, removeOriginHandler };